import type { ICompanyDocument } from '~/types/CompanyDocument';

export function CompanyDocument(companyDocument: string): ICompanyDocument {
  const masked = applyMask(companyDocument);
  const unmasked = removeMask(companyDocument);
  const isValid = validate(companyDocument);
  const isEmpty = hasNoValue(companyDocument);
  const isCompanyDocumentLike = isCompanyDocumentCheck(companyDocument);

  return {
    masked,
    unmasked,
    isValid,
    isEmpty,
    isCompanyDocumentLike,
  };
}

function validate(document: string) {
  if (hasNoValue(document))
    return true;

  const cnpj = removeMask(document);
  if (checkLength(cnpj))
    return false;

  if (checkDigits(cnpj))
    return false;

  let size: any = cnpj.length - 2;
  const digits: any = cnpj.substring(size);
  let numbers: any = cnpj.substring(0, size);
  let sum: any = 0;
  let pos: any = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== Number.parseInt(digits.charAt(0)))
    return false;

  size = size + 1;

  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

  if (result !== Number.parseInt(digits.charAt(1)))
    return false;

  return true;
};

function checkDigits(document: string): boolean {
  const invalid = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ];

  return !!invalid.find(data => data === document);
}

function checkLength(document: string): boolean {
  return document.length !== 14;
}

function removeMask(document: string): string {
  return hasNoValue(document)
    ? ''
    : document.replace(/\D/g, '');
}

export function applyMask(document: string): string {
  return hasNoValue(document)
    ? ''
    : document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

function isCompanyDocumentCheck(document: string): boolean {
  return hasNoValue(document)
    ? false
    : !checkLength(removeMask(document));
}

function hasNoValue(document: string) {
  return !document || document === '';
}
